<div class="skill-list">
  @if (editMode && active) {
    <app-ci-multiselect
      class="skill-select__select"
      [items]="optionSkills"
      [ngModel]="beraterSkills"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onSkillsSelected($event)"
      [displayWith]="displaySkill"
      [compareWith]="compareSkill"
      [placeholder]="searchLabel | translate"
      [searchPlaceholder]="searchLabel | translate"
      [ariaLabel]="searchLabel | translate"
      [countTemplate]="'ciSelect.selectedOfTotal' | translate"
      [removeChipTemplate]="'ciSelect.removeItem' | translate"
      [clearLabel]="'ciSelect.clearSelection' | translate"
      [emptyLabel]="'ciSelect.noMatch' | translate"
    ></app-ci-multiselect>
    <div class="skill-select__button-wrapper">
      <button mat-flat-button (click)='onAddRequestClick()'
              [type]="'button'">{{ 'request.buttons.skills' | translate }}
        <mat-icon>add</mat-icon>
      </button>
    </div>
  }
  @if (!editMode) {
    <div class="task-skills" wikiPreview>
      @for (group of groupedBeraterSkills; track group.skills) {
        <div>
          <h4>{{ group.kategorie }}</h4>
          <mat-chip-set>
            @for (skill of group.skills; track skill.id) {
              <mat-chip>
              <span class="wiki" [attr.data-wp-title]="skill.wikipage">{{
                  skill | vocabulary:'skill'
                }}</span>
              </mat-chip>
            }
          </mat-chip-set>
        </div>
      }
    </div>
  }
</div>

<app-request-dialog
  [type]="RequestType.SKILL"
  modalId="addSkill"
  [title]="'request.buttons.skills'"
  [(visible)]="showModalAddRequest"
  (existingChosen)="onExistingChosen($event)"
></app-request-dialog>
